import { ICON_TYPES } from "@helpscout/hs-marketing-shared-components"
import IconButton, { ICON_BUTTON_VARIANTS } from "@components/IconButton/IconButton"
import { BREAKPOINTS } from "@constants"
import { generateConditionalClassName, isClientSide, throttle } from "@utils"
import React, { FC, RefObject, useEffect, useState } from "react"
import styled from "styled-components"

const PostBookNavMobileToggleDIV = styled.div`
  opacity: 0;
  transition: opacity 0.5s ease-in-out, translate 0.3s;
  translate: 0 -200%;

  &.show-mobile-nav {
    opacity: 1;
    translate: 0;
  }

  &.is-open {
    translate: calc(var(--PostBookNav--max-width));
  }

  &::before {
    background: linear-gradient(to bottom, var(--color--basics-white), rgba(var(--color--basics-white-rgb), 0));
    bottom: 0;
    content: "";
    display: block;
    height: var(--PostBook--nav-toggle-wrapper-height);
    left: calc((100vw - var(--container-width)) / -2);
    position: absolute;
    width: 100vw;
  }

  && .PostBook--nav-toggle {
    background: var(--PostBook--text-color);
    box-shadow: none;
    transition: translate 0.3s;
    vertical-align: bottom;

    .Icon--unordered-list {
      background: var(--PostBook--background);
    }

    .Icon--chevron-left {
      background: var(--PostBook--background);
    }

    &:hover {
      background: var(--PostBook--text-dark-color);

      .Icon--unordered-list {
        background: var(--PostBook--background);
      }

      .Icon--chevron-left {
        background: var(--PostBook--background);
      }
    }
  }
`

const PostBookNavMobileToggle: FC<{
  isNavOpen: boolean,
  onClick: () => void,
  onHide: () => void,
  parentRef: RefObject<HTMLDivElement>
}> = ({
  isNavOpen,
  onClick,
  onHide,
  parentRef,
}) => {
    const [showMobileNav, setShowMobileNav] = useState<boolean>(false)

    useEffect(() => {
      if (!isClientSide() || window.innerWidth >= BREAKPOINTS.L) return

      const scrollBelowStaticNavHandler = throttle(() => {
        const rect = parentRef.current?.querySelector(".PostBookNav.is-static")?.getBoundingClientRect()
        if (!rect) return

        const scrollPoint = window.scrollY + rect.y + rect.height

        if (window.scrollY > scrollPoint) {
          setShowMobileNav(true)
        } else {
          setShowMobileNav(false)
          onHide()
        }
      }, 150)

      window.addEventListener("scroll", scrollBelowStaticNavHandler)

      return () => {
        window.removeEventListener("scroll", scrollBelowStaticNavHandler)
      }
    }, [])

    return (
      <PostBookNavMobileToggleDIV
        className={generateConditionalClassName({
          "is-open": isNavOpen,
          "show-mobile-nav": showMobileNav,
        })}
      >
        <IconButton
          className="PostBook--nav-toggle"
          iconType={isNavOpen ? ICON_TYPES["chevron-left"] : ICON_TYPES["unordered-list"]}
          onClick={onClick}
          variant={ICON_BUTTON_VARIANTS.SECONDARY}
        />
      </PostBookNavMobileToggleDIV>
    )
  }

export default PostBookNavMobileToggle
